import React, { useState } from 'react';
import SuppliesApi from '../../../../API/shipment/supplies-api';
import delete_img from '../../../../assets/media/bucket.svg';
import { ButtonWithTooltip, CheckButton } from '../../../../components/Basic/Buttons';
import { Icon, NavLink } from '../../../../components/Basic/Elements';
import { Input } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { SHIPMENT_STATUS_TEXT, STATUS_COLORS, TO_SUPPLY } from '../../../../constans';
import { getDate } from '../../../../utils';
import DeleteSupplyPopUp from '../DeleteSupplyPopUp';
import styles from '../styles.module.scss';


const SuppliesGroupLine = ({
  suppliesGroup,
  width,
  MARKET_NAME,
  changeSuppliesSelect = _ => { },
  onCloseDelete = _ => { },
  loadSupplies = _ => { },
  suppliesSelect,
  isOwner,
  ...props
}) => {

  const supplies = suppliesGroup.supplies

  const [isOpenSuppliesArray, setIsOpenSuppliesArray] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, supply: {} });

  const openNewTab = (url) => {
    window.open(url, '_blank');
  };

  return (
    <React.Fragment>
      <TableLine
      // style={{ ...(suppliesGroup.is_active ? { background: '#39ee3f35' } : {}) }} 
      >
        <TableCell width={width[0]}>
          <ButtonWithTooltip
            position='right'
            tooltip={'Открыть все поставки'}
            className={styles.button_open}
            style={{ zIndex: 1000, padding: '10px', borderRadius: '3px', backgroundColor: '#e9e9e9ff', border: '1px solid #00000054' }}
            onClick={() => {
              supplies.reverse().forEach(s => {
                console.log('s' + s.id)
                openNewTab(`/fbo/supplies/${s.id}`)
              })
            }}
          >

          </ButtonWithTooltip>
        </TableCell>
        <TableCell center width={width[4]}>
          <a
            style={{ cursor: 'pointer', fontSize: '17px' }}
            href={TO_SUPPLY(supplies.map(s => s.id).join('&'))}
            target='_blank'
          >
            {suppliesGroup._id || '-'}
          </a>
        </TableCell>
        <TableCell width={width[1]}>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setIsOpenSuppliesArray(!isOpenSuppliesArray)
            }}
          >
            {MARKET_NAME[suppliesGroup.market]} / {suppliesGroup.shops.join(', ')}
          </div>

        </TableCell>
        {isOwner &&
          <TableCell width={width[4]} center>
            <div
              style={{ fontSize: '10px', border: '1px solid #00000060', cursor: 'pointer', borderRadius: '5px', padding: '3px 4px', backgroundColor: '#aebc5772' }}
              onClick={async () => {
                await SuppliesApi.updateWorkCost({ data: { supplyIds: supplies.map(s => s.id) } })
              }}
            >
              Пересчитать сделку
            </div>
          </TableCell>
        }
        <TableCell width={width[2]} center>
          {suppliesGroup.sklads.sort().join(', ')}
        </TableCell>
        <TableCell width={width[5]} center>
          {suppliesGroup.count_postings}
        </TableCell>
        <TableCell width={width[7]} center>
          {suppliesGroup.count_ordered}
        </TableCell>
        <TableCell width={width[7]} center>
          {suppliesGroup.count_processed}
        </TableCell>
        <TableCell width={width[7]} center>
          {suppliesGroup.count_accepted}
        </TableCell>
        <TableCell width={width[5]} center>
          {suppliesGroup.sum_boxes}
        </TableCell>
        <TableCell width={width[1]} center>{suppliesGroup.creator}</TableCell>
        <TableCell width={width[0]} center>
          <ButtonWithTooltip
            className={styles.button_active}
            style={{
              border: '1px solid #00000071', padding: '10px', borderRadius: '13px', backgroundColor: suppliesGroup.is_active ? '#32de2cba' : '#e9e9e9ff',
            }}
            tooltip={suppliesGroup.is_active ? 'Убрать активную' : 'Назначить активную'}
            onClick={async () => {
              await SuppliesApi.changeSupplies({ data: { supplyIds: suppliesGroup?.supplies?.map(s => s.id), action: 'make_active', value: !suppliesGroup.is_active } })
              loadSupplies()
            }}
          // disabled={supply.state === 'ended' || supply.state === 'started'}
          >
          </ButtonWithTooltip>
        </TableCell>
        <TableCell width={width[6]} center>
          <Input
            center
            value={suppliesGroup.comment}
            onBlur={async (v) => {
              await SuppliesApi.changeSupplies({ data: { supplyIds: suppliesGroup?.supplies?.map(s => s.id), action: 'change_comment', value: v } })
            }}
          />
        </TableCell>
        <TableCell>

          {/* {isOwner && ( */}

        </TableCell>

      </TableLine>
      {isOpenSuppliesArray && (
        <Table style={{ overflow: 'auto', borderTop: '5px solid #0000004a', borderRight: '0px' }}>
          <TableHeader whiteHeader style={{ fontSize: '12px' }}>
            <HeaderTitle width={width[4]}></HeaderTitle>
            <HeaderTitle width={width[4]}>Id</HeaderTitle>
            <HeaderTitle width={width[5]} centerText >Площадка</HeaderTitle>
            <HeaderTitle width={width[5]} centerText>Дата создания</HeaderTitle>
            <HeaderTitle width={width[5]} centerText>Дата поставки</HeaderTitle>
            <HeaderTitle width={width[1]} centerText>Склад отгрузки</HeaderTitle>
            <HeaderTitle width={width[5]} centerText>Количество заказов</HeaderTitle>
            <HeaderTitle width={width[7]} style={{ fontSize: '10px' }} centerText>Закуплено</HeaderTitle>
            <HeaderTitle width={width[7]} style={{ fontSize: '10px' }} centerText>Обработано</HeaderTitle>
            <HeaderTitle width={width[7]} style={{ fontSize: '10px' }} centerText>Принято</HeaderTitle>
            <HeaderTitle width={width[5]} centerText>Количество коробов</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Статус</HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
          </TableHeader>
          {(supplies || []).map((supply) => {
            return (
              <TableLine key={supply.id} >
                {/* <TableCell width={width[4]}> */}
                {/* </TableCell> */}
                <TableCell width={width[4]} center>
                  <CheckButton
                    checked={suppliesSelect[supply.id]}
                    onSelect={() => changeSuppliesSelect(supply.id)}
                  />
                </TableCell>
                <TableCell width={width[4]}>{supply.id}</TableCell>
                <TableCell width={width[5]}>
                  <NavLink to={TO_SUPPLY(supply.id)} className={styles.line_table_link}>
                    {MARKET_NAME[supply.market]} / {supply.shop}
                  </NavLink>
                </TableCell>
                <TableCell width={width[5]} center>
                  {getDate(supply.dateCreate)}
                </TableCell>
                <TableCell width={width[5]} center>
                  {getDate(supply.wb_info.date)}
                </TableCell>
                <TableCell width={width[1]} center>
                  {supply.wb_info.sklad}
                </TableCell>
                <TableCell width={width[5]} center>
                  {supply.supplies?.[0]?.count_post}
                </TableCell>
                <TableCell width={width[7]} center>
                  {supply.supplies?.[0]?.count_ordered}
                </TableCell>
                <TableCell width={width[7]} center>
                  {supply.supplies?.[0]?.count_processed}
                </TableCell>
                <TableCell width={width[7]} center>
                  {supply.supplies?.[0]?.count_accepted}
                </TableCell>
                <TableCell width={width[5]} center>
                  {supply.boxes.length || 0}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[supply.wb_info.status || supply.state]}` }} center>
                  {supply.wb_info.status || SHIPMENT_STATUS_TEXT[supply.state]}
                </TableCell>
                {/* <TableCell width={width[2]} center>
                  {MAP_SKLAD[supply.sklad]}
                </TableCell> */}
                <TableCell width={width[3]} center>
                  {supply.creator}
                </TableCell>
                <TableCell styles={styles.delete_cell}>
                  {isOwner && (
                    <ButtonWithTooltip
                      tooltip="Удалить"
                      onClick={() => setDeletePopUp({ show: true, supply })}
                      disabled={supply.state === 'ended' || supply.state === 'started'}
                    >
                      <Icon src={delete_img} width={'20px'} />
                    </ButtonWithTooltip>
                  )}
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      )}
      {popUpDelete.show && <DeleteSupplyPopUp supply={popUpDelete.supply} close={() => {
        setIsOpenSuppliesArray(false)
        onCloseDelete()
        setDeletePopUp({ show: false, supply: {} });
      }} />}

    </React.Fragment>

  );
};

export default SuppliesGroupLine;
